module.exports = __webpack_public_path__ + "img/activities-camp.4dfa3c00.jpg";